var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.isLoading)?_c('v-progress-linear',{attrs:{"indeterminate":true,"color":"primary"}}):_vm._e(),(_vm.localData.length > 0)?_c('GChart',{attrs:{"type":"ColumnChart","data":_vm.chartData,"options":_vm.chartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }